import { bbtNative } from '@bbtfe/webview-bridge';
import { lazyWLA } from './lazylib';
import queryString from './query-string';
import { QUERY_KEY_WHITE_MAP, NEW_WEBVIEW_QUERY } from './config';
import { isIOS } from '@utils/device';

// 获取url参数; 正则获取url参数，包含hash[#]和search[?]两种通用
export function getUrlQueryByName(param, url) {
  const reg = new RegExp(`(^|&)${param}=([^&]*)(&|$)`);
  let r = null;
  if (url) {
    const search = url?.split('?');
    r = search?.length > 1 ? search[1]?.match(reg) : null;
  } else {
    r =
      window.location.search.substr(1).match(reg) ||
      window.location.hash
        .substring(window.location.hash.search(/\?/) + 1)
        .match(reg);
  }

  if (r != null) {
    return decodeURIComponent(r[2]);
  }
}

// 清除url中指定参数，并返回url
export function deleteUrlQueryByName(paramArr) {
  let newUrl = window.location.href;
  if (Array.isArray(paramArr) && paramArr?.length > 0) {
    paramArr?.forEach(item => {
      const reg = new RegExp(`(^|&)${item}=([^&]*)(&|$)`);
      const r =
        window.location.search.substr(1).match(reg) ||
        window.location.hash
          .substring(window.location.hash.search(/\?/) + 1)
          .match(reg);
      if (r != null) {
        newUrl = newUrl.replace(`${item}=${decodeURIComponent(r[2])}`, '');
      }
    });
  }
  return newUrl;
}

/**
 * 打电话
 */
export const callPhone = function (tel) {
  window.location.href = `tel:${tel}`;
};

/**
 * 选中文字中的手机号码
 * @param {*} str
 * @param {*} color
 * @returns
 */
export const selectPhoneNumber = function (str, color = '#7B77F6') {
  const regx =
    /(1[3|4|5|7|8|9][\d]{9}|0[\d]{2,3}-[\d]{7,8}|400[-]?[\d]{3}[-]?[\d]{4})/g;
  const phoneNums = str.match(regx) || [];

  const newPhoneNums = phoneNums.filter(
    (item, index) => phoneNums.indexOf(item) == index
  );
  if (newPhoneNums) {
    for (let i = 0; i < newPhoneNums.length; i++) {
      const temp = newPhoneNums[i];
      str = str.replace(
        new RegExp(temp, 'g'),
        `<a href="tel:${temp}" style=" text-decoration:unset; font-family: PingFangSC-Medium, PingFang SC; color:${color} ;">${temp}</a>`
      );
    }
  }
  return str;
};

/**
 * 打开app
 * @description 调用方式 openApp({el:(DOM)})
 */
export function openAppInit({ url, downloadUrl, refcode }) {
  // dp回来的链接有的没有的参数，要加上
  return new Promise((resolve, reject) => {
    if (!bbtNative.isApp()) {
      lazyWLA()
        .then(WLA => {
          resolve(
            new WLA({
              scheme: url,
              pkgs: {
                channel: {
                  refcode: refcode || 'hd_grow_kzlx_20200302',
                  url: downloadUrl || '//r.babytree.com/cX18qAE'
                }
              }
            })
          );
        })
        .catch(() => {
          reject(null);
        });
    }
  });
}

/**
 * 将url转换成path对象
 * @param {*} url 可以是path 或者是含http（s）的完整url
 * @return {object} path对象
 */
export const formatUrlToObj = url => {
  if (!url) return;
  const currentUrlObj = queryString.parseUrl(window.location.href);
  const distUrlObj = queryString.parseUrl(url);
  const passThrough = Object.keys(currentUrlObj.query).reduce(
    (total = {}, item) => {
      if (QUERY_KEY_WHITE_MAP[item]) {
        total[`${item}`] = currentUrlObj.query[`${item}`];
      }
      return total;
    },
    {}
  );
  distUrlObj.query = {
    ...passThrough,
    ...distUrlObj.query
  };

  delete distUrlObj.query[NEW_WEBVIEW_QUERY];
  return distUrlObj;
};

export const getQuery = () => {
  const query = queryString.parseUrl(window.location.href)?.query;
  Object.keys(query)?.map(key => {
    if (typeof query[key] !== 'string') {
      query[key] = query[key]?.[0];
    }
  });
  return query;
};

export const getBirthday = () => {
  const query = getQuery();
  return query['bpreg-brithday'] || '1900-01-01';
};

export const isNavHidden = () => {
  return bbtNative?.isApp() && getQuery()?.navigation_bar_hidden && isIOS();
};

// 拼接埋点参数
export const concatJumpUrlParams = ({ url, pi, ii, bpi, href, sData }) => {
  let trackParam = {};
  if (!!!url) {
    return trackParam;
  }
  if (!!pi) {
    trackParam['referer_pageid'] = encodeURIComponent(pi);
  }
  if (!!ii) {
    trackParam['referer_item_id'] = encodeURIComponent(ii);
  }
  let referer_pagevalue = '';
  if (!!bpi) {
    referer_pagevalue = referer_pagevalue + 'bpi=' + bpi;
  }
  if (!!href) {
    referer_pagevalue = referer_pagevalue + '$' + href; // 对应be参数
  }
  if (sData && !!sData.abtest) {
    referer_pagevalue = referer_pagevalue + `$ABtest=${sData.abtest}`;
  }
  if (sData && !!sData.followid) {
    referer_pagevalue = referer_pagevalue + `$followid=${sData.followid}`;
  }
  if (sData && !!sData.traceId) {
    referer_pagevalue = referer_pagevalue + `$trace_id=${sData.traceId}`;
  }
  if (sData && !!sData.traceInfo) {
    referer_pagevalue = referer_pagevalue + `$trace_info=${sData.traceInfo}`;
  }
  trackParam['referer_pagevalue'] = referer_pagevalue;
  return trackParam;
};
